import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({ spacing }) => ({
  page: {
    minHeight: "100vh",
    backgroundColor: "#fafafa",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: spacing(4, 2),
  },
  loader: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: 600,
    maxWidth: "100%",
    padding: spacing(7, 5, 3),
    backgroundColor: "#ffffff",
    borderRadius: 12,
    textAlign: "center",
    fontFamily: "'Poppins','Helvetica Neue',Helvetica,Arial,sans-serif",
  },

  logos: {
    display: "flex",
    justifyContent: "center",
    gap: 16,
    marginBottom: spacing(2),
  },
  logoBox: {
    width: 80,
    height: 80,
    borderRadius: 16,
    border: "1px solid #e0e0e0",
    backgroundColor: "#fafafa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    "& svg": {
      width: "100%",
      height: "100%",
      display: "block",
    },
  },
  logoBoxSupplier: {
    backgroundColor: "#fafafa",
  },
  logoImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },

  greeting: {
    fontSize: 24,
    fontWeight: 500,
    color: "#000000",
    marginBottom: spacing(3),
  },

  bodyCard: {
    border: "1px solid #e0e0e0",
    borderRadius: 12,
    marginBottom: spacing(3),
  },
  body: {
    color: "#212121",
    fontSize: 14,
    lineHeight: 1.5,
    textAlign: "center",
    padding: spacing(3, 2, 2),
    "& p": { margin: "0 0 16px" },
    "& p:last-child": { marginBottom: 0 },
  },

  invoiceOuter: {
    backgroundColor: "#fafafa",
    border: "1px solid #f5f5f5",
    borderRadius: 8,
    margin: spacing(0, 2, 3),
    padding: spacing(2, 3, 3),
  },
  invoiceRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    height: 48,
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    padding: spacing(0.75, 1),
  },
  fileIcon: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  fileSize: {
    flexShrink: 0,
    color: "#757575",
    fontSize: 14,
    whiteSpace: "nowrap",
  },
  fileName: {
    flex: 1,
    minWidth: 0,
    textAlign: "left",
    color: "#000000",
    fontSize: 14,
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  newTab: {
    flexShrink: 0,
    color: "#9e9e9e",
    fontSize: 18,
    lineHeight: 1,
  },

  ctaWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: spacing(6),
  },
  cta: {
    display: "inline-block",
    padding: spacing(1, 2),
    fontSize: 14,
    fontWeight: 600,
    color: "#ffffff",
    textTransform: "uppercase",
    textDecoration: "none",
    borderRadius: 20,
    backgroundColor: "#2979ff",
  },

  footer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  disclaimer: {
    fontSize: 12,
    fontWeight: 300,
    fontStyle: "italic",
    color: "#bdbdbd",
    lineHeight: "normal",
    marginBottom: spacing(2),
    textAlign: "center",
  },
}));

export default useStyles;
